// import React, { createContext, useState, useEffect, useCallback } from 'react';
// import { useNavigate } from "react-router-dom";
// import authService from './services/authService';
// import useSessionTimeout from './services/useSessionTimeout';

// const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {

//     const navigate = useNavigate();

//     const [isSignedIn, setIsSignedIn] = useState(false);
//     const [user, setUser] = useState(null);
   

//     const signIn = async (phoneNumber) => {        
//         try {
//             const response = await authService.login(phoneNumber);   
//             const userId = response.data.user.id;
//             const user = await authService.getUser(userId);
//             setIsSignedIn(true);

//             localStorage.setItem('token', response.data.token);
//             localStorage.setItem('user', JSON.stringify(user));
//             localStorage.setItem('loginTimestamp', Date.now());

//             setUser(user);
//             return user, response;           
//         } catch (error) {
//             setIsSignedIn(false);
//             setUser(null);
//             throw error;
//         }
//     };

//     const signOut = async () => {
//         try {
//             const response = await authService.logout();            
//             if (response) {
//                 setIsSignedIn(false);
//                 setUser(null);
//                 localStorage.removeItem('token');
//                 localStorage.removeItem('user');
//                 clearTimeout(window.sessionTimeout);
//                 navigate('/');
//             } else {
//                 console.error('Sign out failed:', response);
//             }
//         } catch (error) {
//             console.error('Sign out error:', error);
//         }
//     };

//     const startSessionTimer = useCallback(() => {
//         clearTimeout(window.sessionTimeout);
//         window.sessionTimeout = setTimeout(() => {
//             signOut();
//             navigate('/'); 
//         }, SESSION_TIMEOUT);
//     }, [signOut, navigate]);
  
//     useSessionTimeout(isSignedIn, signOut); // Use the custom hook

//     useEffect(() => {
//         const token = localStorage.getItem('token');
//         const userData = localStorage.getItem('user');
//         const loginTimestamp = localStorage.getItem('loginTimestamp');
    
//         if (token && userData && loginTimestamp) {
//             const currentTime = Date.now();
//             const elapsedTime = currentTime - loginTimestamp;
//             if (elapsedTime < SESSION_TIMEOUT) {
//                 setIsSignedIn(true);
//                 setUser(JSON.parse(userData));
//                 startSessionTimer(); // Restart the session timer if the session is still valid
//             } else {
//                 signOut(); // Sign out if the session has expired
//             }
//         }
//     }, [signOut, startSessionTimer]);
    

//     return (
//         <AuthContext.Provider value={{ isSignedIn, user, signIn, signOut }}>
//             {children}
//         </AuthContext.Provider>
//     );
// };

// export default AuthContext;

// import React, { createContext, useState, useEffect, useCallback } from 'react';
// import { useNavigate } from "react-router-dom";
// import authService from '../services/authService';
// import useSessionTimeout from '../services/useSessionTimeout';

// const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {

//     const navigate = useNavigate();

//     const [isSignedIn, setIsSignedIn] = useState(false);
//     const [user, setUser] = useState(null);

//     const signIn = async (phoneNumber) => {        
//         try {
//             const response = await authService.login(phoneNumber);   
//             const userId = response.data.user.id;
//             const user = await authService.getUser(userId);
//             setIsSignedIn(true);

//             localStorage.setItem('token', response.data.token);
//             localStorage.setItem('user', JSON.stringify(user));
//             localStorage.setItem('loginTimestamp', Date.now());

//             setUser(user);
//             return user, response;  // return as object for both
//         } catch (error) {
//             setIsSignedIn(false);
//             setUser(null);
//             throw error;
//         }
//     };

//     const signOut = useCallback(async () => {
//         try {
//             const response = await authService.logout();            
//             if (response) {
//                 setIsSignedIn(false);
//                 setUser(null);
//                 localStorage.removeItem('token');
//                 localStorage.removeItem('user');
//                 clearTimeout(window.sessionTimeout);
//                 navigate('/');
//             } else {
//                 console.error('Sign out failed:', response);
//             }
//         } catch (error) {
//             console.error('Sign out error:', error);
//         }
//     }, [navigate]);

//     const startSessionTimer = useCallback(() => {
//         clearTimeout(window.sessionTimeout);
//         window.sessionTimeout = setTimeout(() => {
//             signOut();
//         }, SESSION_TIMEOUT);
//     }, [signOut]);
  
//     useSessionTimeout(isSignedIn, signOut);

//     useEffect(() => {
//         const token = localStorage.getItem('token');
//         const userData = localStorage.getItem('user');
//         const loginTimestamp = localStorage.getItem('loginTimestamp');
    
//         if (token && userData && loginTimestamp) {
//             const currentTime = Date.now();
//             const elapsedTime = currentTime - loginTimestamp;
//             if (elapsedTime < SESSION_TIMEOUT) {
//                 setIsSignedIn(true);
//                 setUser(JSON.parse(userData));
//                 startSessionTimer();
//             } else {
//                 signOut();
//             }
//         }
        
//         // Clean-up function to clear the session timeout when component unmounts
//         return () => clearTimeout(window.sessionTimeout);

//     }, [startSessionTimer, signOut]);
    
//     return (
//         <AuthContext.Provider value={{ isSignedIn, user, signIn, signOut }}>
//             {children}
//         </AuthContext.Provider>
//     );
// };

// export default AuthContext;


// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import authService from '../services/authService';
// import useSessionTimeout from '../services/useSessionTimeout';

// const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds

// const AuthContext = createContext();

// // Every storage key is namespaced to the tenant this provider instance was
// // created for. Tenant A and tenant B never share a slot, so there's no
// // "mismatch" to detect and clear after the fact — cross-tenant leakage is
// // structurally impossible rather than something we catch reactively.
// const keyFor = (tenant, name) => `${name}_${tenant}`;

// // One-time cleanup of the old un-namespaced keys from before this fix
// // existed (`token`, `user`, `loginTimestamp`, `authTenant`) — these could
// // otherwise sit in localStorage forever and confuse debugging later.
// const purgeLegacyKeys = () => {
//     ['token', 'user', 'loginTimestamp', 'authTenant'].forEach((k) =>
//         localStorage.removeItem(k),
//     );
// };

// export const AuthProvider = ({ tenant, children }) => {
//     const [isSignedIn, setIsSignedIn] = useState(false);
//     const [user, setUser] = useState(null);

//     const clearLocalSession = useCallback(() => {
//         setIsSignedIn(false);
//         setUser(null);
//         if (tenant) {
//             localStorage.removeItem(keyFor(tenant, 'token'));
//             localStorage.removeItem(keyFor(tenant, 'user'));
//             localStorage.removeItem(keyFor(tenant, 'loginTimestamp'));
//         }
//         clearTimeout(window.sessionTimeout);
//     }, [tenant]);

//     // Persists a fully-authenticated session under this tenant's own keys.
//     // Mirrors the old Redux shape ({ ...user, token }) so every existing
//     // call site reading `user.token` keeps working unchanged.
//     const persistSession = useCallback((rawUser, token) => {
//         const merged = { ...rawUser, token };
//         setIsSignedIn(true);
//         setUser(merged);
//         localStorage.setItem(keyFor(tenant, 'token'), token);
//         localStorage.setItem(keyFor(tenant, 'user'), JSON.stringify(merged));
//         localStorage.setItem(keyFor(tenant, 'loginTimestamp'), Date.now());
//         return merged;
//     }, [tenant]);

//     const signOut = useCallback(async () => {
//         try {
//             await authService.logout();
//         } catch (error) {
//             console.error('Sign out error:', error);
//         } finally {
//             clearLocalSession();
//         }
//     }, [clearLocalSession]);

//     const startSessionTimer = useCallback(() => {
//         clearTimeout(window.sessionTimeout);
//         window.sessionTimeout = setTimeout(() => {
//             signOut();
//         }, SESSION_TIMEOUT);
//     }, [signOut]);

//     useSessionTimeout(isSignedIn, signOut);

//     // ── Auth actions — tenant is already known to this provider instance,
//     // so callers just pass credentials/OTP, no tenant argument needed. ────

//     const login = useCallback(async (credentials) => {
//         const data = await authService.login(tenant, credentials);
//         if (data.user && data.token) {
//             const merged = persistSession(data.user, data.token);
//             startSessionTimer();
//             return { ...data, user: merged };
//         }
//         return data; // { step: 'verify_email' | 'verify_phone', user_id }
//     }, [tenant, persistSession, startSessionTimer]);

//     const register = useCallback(async (formData) => {
//         return authService.register(tenant, formData); // { user_id } -> verify_email
//     }, [tenant]);

//     const verifyEmail = useCallback(async (userId, otp) => {
//         return authService.verifyEmail(tenant, userId, otp); // { user_id } -> verify_phone
//     }, [tenant]);

//     const verifyPhone = useCallback(async (userId, otp) => {
//         const data = await authService.verifyPhone(tenant, userId, otp);
//         const merged = persistSession(data.user, data.token);
//         startSessionTimer();
//         return { ...data, user: merged };
//     }, [tenant, persistSession, startSessionTimer]);

//     const resendOtp = useCallback(async (userId, type) => {
//         return authService.resendOtp(tenant, userId, type);
//     }, [tenant]);

//     // ── Restore this tenant's session on mount (and whenever the tenant
//     // prop itself changes, e.g. TenantLayout remounting for a new tenant
//     // slug) — reading only from this tenant's own namespaced keys, so
//     // there's nothing from another tenant to accidentally pick up. ──────
//     useEffect(() => {
//         purgeLegacyKeys();

//         if (!tenant) {
//             clearLocalSession();
//             return;
//         }

//         const token = localStorage.getItem(keyFor(tenant, 'token'));
//         const userData = localStorage.getItem(keyFor(tenant, 'user'));
//         const loginTimestamp = localStorage.getItem(keyFor(tenant, 'loginTimestamp'));

//         if (token && userData && loginTimestamp) {
//             const elapsed = Date.now() - loginTimestamp;
//             if (elapsed < SESSION_TIMEOUT) {
//                 setIsSignedIn(true);
//                 setUser(JSON.parse(userData));
//                 startSessionTimer();
//             } else {
//                 clearLocalSession();
//             }
//         } else {
//             // No valid session for this specific tenant — make sure state
//             // reflects that even if a previous tenant's provider instance
//             // left `isSignedIn`/`user` set (defensive; shouldn't happen
//             // since each tenant remount gets a fresh provider, but cheap
//             // to guarantee).
//             setIsSignedIn(false);
//             setUser(null);
//         }

//         return () => clearTimeout(window.sessionTimeout);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [tenant]);

//     return (
//         <AuthContext.Provider
//             value={{
//                 isSignedIn,
//                 user,
//                 login,
//                 register,
//                 verifyEmail,
//                 verifyPhone,
//                 resendOtp,
//                 signOut,
//             }}
//         >
//             {children}
//         </AuthContext.Provider>
//     );
// };

// export const useAuth = () => useContext(AuthContext);

// export default AuthContext;

// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import authService from '../services/authService';
// import useSessionTimeout from '../services/useSessionTimeout';

// const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds

// const AuthContext = createContext();

// // Every storage key is namespaced to the tenant this provider instance was
// // created for. Tenant A and tenant B never share a slot, so there's no
// // "mismatch" to detect and clear after the fact — cross-tenant leakage is
// // structurally impossible rather than something we catch reactively.
// const keyFor = (tenant, name) => `${name}_${tenant}`;

// // One-time cleanup of the old un-namespaced keys from before this fix
// // existed (`token`, `user`, `loginTimestamp`, `authTenant`).
// const purgeLegacyKeys = () => {
//     ['token', 'user', 'loginTimestamp', 'authTenant'].forEach((k) =>
//         localStorage.removeItem(k),
//     );
// };

// export const AuthProvider = ({ tenant, children }) => {
//     const [isSignedIn, setIsSignedIn] = useState(false);
//     const [user, setUser] = useState(null);

//     const clearLocalSession = useCallback(() => {
//         setIsSignedIn(false);
//         setUser(null);
//         if (tenant) {
//             localStorage.removeItem(keyFor(tenant, 'token'));
//             localStorage.removeItem(keyFor(tenant, 'user'));
//             localStorage.removeItem(keyFor(tenant, 'loginTimestamp'));
//         }
//         clearTimeout(window.sessionTimeout);
//     }, [tenant]);

//     // Persists a fully-authenticated session under this tenant's own keys.
//     // Mirrors the old Redux shape ({ ...user, token }) so every existing
//     // call site reading `user.token` keeps working unchanged.
//     const persistSession = useCallback((rawUser, token) => {
//         const merged = { ...rawUser, token };
//         setIsSignedIn(true);
//         setUser(merged);
//         localStorage.setItem(keyFor(tenant, 'token'), token);
//         localStorage.setItem(keyFor(tenant, 'user'), JSON.stringify(merged));
//         localStorage.setItem(keyFor(tenant, 'loginTimestamp'), Date.now());
//         return merged;
//     }, [tenant]);

//     // Merges a partial update into the current user (e.g. after refreshing
//     // /user/me, or after saving profile edits) without touching the token
//     // or forcing a re-login. Replaces the old dispatch(setUser(...)).
//     const updateUser = useCallback((patch) => {
//         setUser((prev) => {
//             if (!prev) return prev;
//             const merged = { ...prev, ...patch, token: prev.token };
//             if (tenant) {
//                 localStorage.setItem(keyFor(tenant, 'user'), JSON.stringify(merged));
//             }
//             return merged;
//         });
//     }, [tenant]);

//     const signOut = useCallback(async () => {
//         try {
//             await authService.logout();
//         } catch (error) {
//             console.error('Sign out error:', error);
//         } finally {
//             clearLocalSession();
//         }
//     }, [clearLocalSession]);

//     const startSessionTimer = useCallback(() => {
//         clearTimeout(window.sessionTimeout);
//         window.sessionTimeout = setTimeout(() => {
//             signOut();
//         }, SESSION_TIMEOUT);
//     }, [signOut]);

//     useSessionTimeout(isSignedIn, signOut);

//     // ── Auth actions — tenant is already known to this provider instance,
//     // so callers just pass credentials/OTP, no tenant argument needed. ────

//     const login = useCallback(async (credentials) => {
//         const data = await authService.login(tenant, credentials);
//         if (data.user && data.token) {
//             const merged = persistSession(data.user, data.token);
//             startSessionTimer();
//             return { ...data, user: merged };
//         }
//         return data; // { step: 'verify_email' | 'verify_phone', user_id }
//     }, [tenant, persistSession, startSessionTimer]);

//     const register = useCallback(async (formData) => {
//         return authService.register(tenant, formData); // { user_id } -> verify_email
//     }, [tenant]);

//     const verifyEmail = useCallback(async (userId, otp) => {
//         return authService.verifyEmail(tenant, userId, otp); // { user_id } -> verify_phone
//     }, [tenant]);

//     const verifyPhone = useCallback(async (userId, otp) => {
//         const data = await authService.verifyPhone(tenant, userId, otp);
//         const merged = persistSession(data.user, data.token);
//         startSessionTimer();
//         return { ...data, user: merged };
//     }, [tenant, persistSession, startSessionTimer]);

//     const resendOtp = useCallback(async (userId, type) => {
//         return authService.resendOtp(tenant, userId, type);
//     }, [tenant]);

//     // ── Restore this tenant's session on mount (and whenever the tenant
//     // prop itself changes) — reading only from this tenant's own
//     // namespaced keys, so there's nothing from another tenant to
//     // accidentally pick up. ─────────────────────────────────────────────
//     useEffect(() => {
//         purgeLegacyKeys();

//         if (!tenant) {
//             clearLocalSession();
//             return;
//         }

//         const token = localStorage.getItem(keyFor(tenant, 'token'));
//         const userData = localStorage.getItem(keyFor(tenant, 'user'));
//         const loginTimestamp = localStorage.getItem(keyFor(tenant, 'loginTimestamp'));

//         if (token && userData && loginTimestamp) {
//             const elapsed = Date.now() - loginTimestamp;
//             if (elapsed < SESSION_TIMEOUT) {
//                 setIsSignedIn(true);
//                 setUser(JSON.parse(userData));
//                 startSessionTimer();
//             } else {
//                 clearLocalSession();
//             }
//         } else {
//             setIsSignedIn(false);
//             setUser(null);
//         }

//         return () => clearTimeout(window.sessionTimeout);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [tenant]);

//     return (
//         <AuthContext.Provider
//             value={{
//                 isSignedIn,
//                 user,
//                 login,
//                 register,
//                 verifyEmail,
//                 verifyPhone,
//                 resendOtp,
//                 updateUser,
//                 signOut,
//             }}
//         >
//             {children}
//         </AuthContext.Provider>
//     );
// };

// export const useAuth = () => useContext(AuthContext);

// export default AuthContext;


import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import authService from '../services/authService';
import useSessionTimeout from '../services/useSessionTimeout';

const SESSION_TIMEOUT = 60 * 60 * 1000; // 30 minutes in milliseconds

const AuthContext = createContext();

// Every storage key is namespaced to the tenant this provider instance was
// created for. Tenant A and tenant B never share a slot, so there's no
// "mismatch" to detect and clear after the fact — cross-tenant leakage is
// structurally impossible rather than something we catch reactively.
const keyFor = (tenant, name) => `${name}_${tenant}`;

// One-time cleanup of the old un-namespaced keys from before this fix
// existed (`token`, `user`, `loginTimestamp`, `authTenant`).
const purgeLegacyKeys = () => {
    ['token', 'user', 'loginTimestamp', 'authTenant'].forEach((k) =>
        localStorage.removeItem(k),
    );
};

export const AuthProvider = ({ tenant, children }) => {
    const [isSignedIn, setIsSignedIn] = useState(false);
    const [user, setUser] = useState(null);
    // True until the localStorage restore attempt below has run at least
    // once for the current tenant. Consumers (e.g. a dashboard's own
    // "redirect if logged out" effect) must wait for this to go false
    // before treating `user === null` as "actually logged out" — otherwise
    // they race this provider's own restore effect (child effects fire
    // before parent effects on mount) and redirect on the very first
    // render, before session data has even been read from storage.
    const [initializing, setInitializing] = useState(true);

    const clearLocalSession = useCallback(() => {
        setIsSignedIn(false);
        setUser(null);
        if (tenant) {
            localStorage.removeItem(keyFor(tenant, 'token'));
            localStorage.removeItem(keyFor(tenant, 'user'));
            localStorage.removeItem(keyFor(tenant, 'loginTimestamp'));
        }
        clearTimeout(window.sessionTimeout);
    }, [tenant]);

    // Persists a fully-authenticated session under this tenant's own keys.
    // Mirrors the old Redux shape ({ ...user, token }) so every existing
    // call site reading `user.token` keeps working unchanged.
    const persistSession = useCallback((rawUser, token) => {
        const merged = { ...rawUser, token };
        setIsSignedIn(true);
        setUser(merged);
        localStorage.setItem(keyFor(tenant, 'token'), token);
        localStorage.setItem(keyFor(tenant, 'user'), JSON.stringify(merged));
        localStorage.setItem(keyFor(tenant, 'loginTimestamp'), Date.now());
        return merged;
    }, [tenant]);

    // Merges a partial update into the current user (e.g. after refreshing
    // /user/me, or after saving profile edits) without touching the token
    // or forcing a re-login. Replaces the old dispatch(setUser(...)).
    const updateUser = useCallback((patch) => {
        setUser((prev) => {
            if (!prev) return prev;
            const merged = { ...prev, ...patch, token: prev.token };
            if (tenant) {
                localStorage.setItem(keyFor(tenant, 'user'), JSON.stringify(merged));
            }
            return merged;
        });
    }, [tenant]);

    const signOut = useCallback(async () => {
        try {
            await authService.logout();
        } catch (error) {
            console.error('Sign out error:', error);
        } finally {
            clearLocalSession();
        }
    }, [clearLocalSession]);

    const startSessionTimer = useCallback(() => {
        clearTimeout(window.sessionTimeout);
        window.sessionTimeout = setTimeout(() => {
            signOut();
        }, SESSION_TIMEOUT);
    }, [signOut]);

    useSessionTimeout(isSignedIn, signOut);

    // ── Auth actions — tenant is already known to this provider instance,
    // so callers just pass credentials/OTP, no tenant argument needed. ────

    const login = useCallback(async (credentials) => {
        const data = await authService.login(tenant, credentials);
        if (data.user && data.token) {
            const merged = persistSession(data.user, data.token);
            startSessionTimer();
            return { ...data, user: merged };
        }
        return data; // { step: 'verify_email' | 'verify_phone', user_id }
    }, [tenant, persistSession, startSessionTimer]);

    const register = useCallback(async (formData) => {
        return authService.register(tenant, formData); // { user_id } -> verify_email
    }, [tenant]);

    const verifyEmail = useCallback(async (userId, otp) => {
        return authService.verifyEmail(tenant, userId, otp); // { user_id } -> verify_phone
    }, [tenant]);

    const verifyPhone = useCallback(async (userId, otp) => {
        const data = await authService.verifyPhone(tenant, userId, otp);
        const merged = persistSession(data.user, data.token);
        startSessionTimer();
        return { ...data, user: merged };
    }, [tenant, persistSession, startSessionTimer]);

    const resendOtp = useCallback(async (userId, type) => {
        return authService.resendOtp(tenant, userId, type);
    }, [tenant]);

    // ── Restore this tenant's session on mount (and whenever the tenant
    // prop itself changes) — reading only from this tenant's own
    // namespaced keys, so there's nothing from another tenant to
    // accidentally pick up. ─────────────────────────────────────────────
    useEffect(() => {
        setInitializing(true);
        purgeLegacyKeys();

        if (!tenant) {
            clearLocalSession();
            setInitializing(false);
            return;
        }

        const token = localStorage.getItem(keyFor(tenant, 'token'));
        const userData = localStorage.getItem(keyFor(tenant, 'user'));
        const loginTimestamp = localStorage.getItem(keyFor(tenant, 'loginTimestamp'));

        if (token && userData && loginTimestamp) {
            const elapsed = Date.now() - loginTimestamp;
            if (elapsed < SESSION_TIMEOUT) {
                setIsSignedIn(true);
                setUser(JSON.parse(userData));
                startSessionTimer();
            } else {
                clearLocalSession();
            }
        } else {
            setIsSignedIn(false);
            setUser(null);
        }

        setInitializing(false);

        return () => clearTimeout(window.sessionTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenant]);

    return (
        <AuthContext.Provider
            value={{
                isSignedIn,
                user,
                initializing,
                login,
                register,
                verifyEmail,
                verifyPhone,
                resendOtp,
                updateUser,
                signOut,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
